import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH, ERROR_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'contact-admin',
        path: `${AUTH_PREFIX_PATH}/contact-admin`,
        component: React.lazy(() => import('views/auth-views/authentication/contact-admin')),
    },
    {
        key: 'error-page-4xx',
        path: `${ERROR_PREFIX_PATH}/4xx`,
        component: React.lazy(() => import('views/errors/error-page-4xx')),
    },
    {
        key: 'error-page-5xx',
        path: `${ERROR_PREFIX_PATH}/5xx`,
        component: React.lazy(() => import('views/errors/error-page-5xx')),
    }
]

export const protectedRoutes = [
    // Dashboard
    {
        key: 'dashboard.home',
        path: `${APP_PREFIX_PATH}/dashboards/home`,
        component: React.lazy(() => import('views/app-views/dashboards/home')),
    },
    {
        key: 'dashboard.analytics',
        path: `${APP_PREFIX_PATH}/dashboards/analytics`,
        component: React.lazy(() => import('views/app-views/dashboards/analytics')),
    },
    // Application
    {
        key: 'application.users',
        path: `${APP_PREFIX_PATH}/application/users`,
        component: React.lazy(() => import('views/app-views/application/users')),
    },
    {
        key: 'application.transport-status',
        path: `${APP_PREFIX_PATH}/application/transport-status`,
        component: React.lazy(() => import('views/app-views/application/transport-status')),
    },
    // Administration
    {
        key: 'admin.firebase.modes',
        path: `${APP_PREFIX_PATH}/admin/firebase/modes`,
        component: React.lazy(() => import('views/app-views/admin/firebase/modes')),
    },
    {
        key: 'admin.firebase.routes',
        path: `${APP_PREFIX_PATH}/admin/firebase/routes`,
        component: React.lazy(() => import('views/app-views/admin/firebase/routes')),
    },
    {
        key: 'admin.firebase.stops',
        path: `${APP_PREFIX_PATH}/admin/firebase/stops`,
        component: React.lazy(() => import('views/app-views/admin/firebase/stops')),
    },
    {
        key: 'admin.firebase.cron-jobs',
        path: `${APP_PREFIX_PATH}/admin/firebase/cron-jobs`,
        component: React.lazy(() => import('views/app-views/admin/firebase/cron-jobs')),
    },
    {
        key: 'admin.firebase.system-resources',
        path: `${APP_PREFIX_PATH}/admin/firebase/system-resources`,
        component: React.lazy(() => import('views/app-views/admin/firebase/system-resources')),
    },
]
